// src/components/PublicHeader.js
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Transition } from '@headlessui/react';

const PublicHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'For Churches', path: '/for-churches' },
    { name: 'About', path: '/about' },
    { name: 'Partners', path: '/partners' },
    { 
      name: 'Blog', 
      path: 'https://www.togetheronmission.org/blog',
      external: true 
    }
  ];

  return (
    <header className="bg-gray-800 sticky top-0 z-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo - Same for all breakpoints */}
          <div className="flex items-center">
            <Link to="/landing" className="flex items-center">
              <img
                src="/images/TOM-logo-512.png"
                alt="Together On Mission Logo"
                className="h-16 w-auto mr-3"
              />
              <div className="flex flex-col">
                <span className="text-white font-bold text-lg leading-tight">
                  Together On Mission
                </span>
                <span className="text-gray-400 text-xs">
                  Go Make Disciples
                </span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation - Hidden on mobile, visible on md and up */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            {navLinks.map((link) => (
              link.external ? (
                <a
                  key={link.name}
                  href={link.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white px-3 py-2"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-gray-300 hover:text-white px-3 py-2"
                >
                  {link.name}
                </Link>
              )
            ))}
            <Link
              to="/login"
              className="text-gray-300 hover:text-white px-3 py-2"
            >
              Login
            </Link>
            <Link
              to="/signup"
              className="bg-[#5ABA47] text-white px-4 py-2 rounded-md hover:bg-[#4a9539] transition-colors"
            >
              Sign Up
            </Link>
          </div>

          {/* Mobile Navigation Controls - Visible on mobile only */}
          <div className="flex items-center space-x-4 md:hidden">
            <Link
              to="/login"
              className="text-gray-300 hover:text-white px-3 py-2"
            >
              Login
            </Link>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-300 hover:text-white"
              aria-expanded={isMobileMenuOpen}
            >
              {isMobileMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu - Absolute positioning with transition */}
      <Transition
        show={isMobileMenuOpen}
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-150"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <div className="absolute top-16 inset-x-0 z-50 md:hidden">
          <div className="bg-gray-800 border-t border-gray-700 shadow-lg">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navLinks.map((link) => (
                link.external ? (
                  <a
                    key={link.name}
                    href={link.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-base font-medium"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {link.name}
                  </a>
                ) : (
                  <Link
                    key={link.name}
                    to={link.path}
                    className="block text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-base font-medium"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {link.name}
                  </Link>
                )
              ))}
              <Link
                to="/signup"
                className="block bg-[#5ABA47] text-white px-3 py-2 rounded-md hover:bg-[#4a9539] transition-colors mt-4 text-base font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      </Transition>
    </header>
  );
};

export default PublicHeader;
